export default __webpack_public_path__ + "static/media/sweet_chili_chicken.957b9057.png";